export type ExcelColumn = {
  header: string;
  width?: number;
  align?: 'left' | 'right' | 'center';
};

export type ExcelCell = {
  value: string | number | null;
  money?: boolean;
};

type ExportToExcelParams = {
  fileName: string;
  sheetName: string;
  columns: ExcelColumn[];
  rows: ExcelCell[][];
};

const MONEY_FORMAT = '"R$" #,##0.00';

// exceljs é carregado só quando o usuário exporta, para não pesar o bundle inicial.
export async function exportToExcel({ fileName, sheetName, columns, rows }: ExportToExcelParams) {
  const { Workbook } = await import('exceljs');

  const workbook = new Workbook();
  const sheet = workbook.addWorksheet(sheetName.slice(0, 31));

  sheet.columns = columns.map(column => ({
    header: column.header,
    width: Math.max(10, Math.round((column.width ?? 100) / 7)),
  }));

  rows.forEach(cells => {
    const row = sheet.addRow(cells.map(cell => cell.value));
    cells.forEach((cell, index) => {
      if (cell.money) row.getCell(index + 1).numFmt = MONEY_FORMAT;
    });
  });

  columns.forEach((column, index) => {
    if (column.align) sheet.getColumn(index + 1).alignment = { horizontal: column.align };
  });

  const header = sheet.getRow(1);
  header.font = { bold: true };
  header.alignment = { vertical: 'middle' };
  sheet.views = [{ state: 'frozen', ySplit: 1 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
